// 快递存，流程导航
<template>
  <div class="flow expressSaveFlow">
    <ul
      class="nav"
      :style="{backgroundPositionY: -(index-1) + 'rem'}">
      <li class="li" :class="{active : index == 1}">1. 请扫描您的员工卡</li>
      <li class="li" :class="{active : index == 2}">2. 选择箱格大小</li>
      <li class="li" :class="{active : index == 3}">3. 输入取件人手机号</li>
      <li class="li" :class="{active : index == 4}">4. 扫描快递条码</li>
      <li class="li" :class="{active : index == 5}">5. 存入物品完成</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'expressSaveFlow',
  props: ['index'],
  data () {
    return {
    }
  },
  created () {
  },
  watch: {
  }
}
</script>

<style scoped>
.flow.expressSaveFlow .nav{
  width: 16.45rem;
  background-image: url(/../static/turnoverCabinet/images/flow/expressSaveFlow.png);
  background-repeat: no-repeat;
  background-position-x: 0;
  background-size: 16.45rem 5rem;
}

.flow.expressSaveFlow .nav .li {
  width: 20%;
}

.flow.expressSaveFlow .nav .li:nth-child(3){
  text-indent: 0.19rem;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/expressSave/expressSaveFlow.vue